import React, { useEffect, useState } from "react";
import "./profile.css"; // Import the CSS for styling
import Layout from "../layout/Layout";
import Admin from "../auth/Admin";
import Avatar from "@mui/material/Avatar";
import Stack from "@mui/material/Stack";
import { isAuth } from "../../actions/auth";
import StaffChangePassword from "../forms/staffChangePassword";
import Popup from "../customHelpers/Popup";

import { Box } from "@mui/material";
import { Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import Controls from "../controls/Controls";
import Notify from "../customHelpers/Notify";
import Notification from "../customHelpers/Notification";
import Staff from "../../actions/staff";
import SuperAdmin from "../../actions/manageAdmin";

import ProfileDetails from "./profiel";
const ProfilePage = () => {
  const [data, setData] = useState(null);
  const [superadmin, setSuperadmin] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const { viewStaff } = Staff();
  const { getAdmin } = SuperAdmin();
  const { NotifyMessage, notify, setNotify } = Notify();

  useEffect(() => {
    if (isAuth()) {
      if (isAuth()?.role === "superadmin") {
        getSuperadminData();
      } else {
        getStaffData();
      }
    }
  }, []);
  const getStaffData = () => {
    viewStaff(isAuth()?.id).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.staf) {
        setData(data.staf);
      }
    });
  };

  const getSuperadminData = () => {
    getAdmin(isAuth()?.id).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.admin) {
        setSuperadmin(data.admin);
      }
    });
  };

  return (
    <Layout>
      <Admin>
        <div className="profile-container">
          <div className="profile-header">
            <Stack direction="row" spacing={2}>
              <Avatar></Avatar>
            </Stack>
            <h1 className="profile-name">
              {isAuth()?.role === "superadmin"
                ? superadmin?.fullName
                : data?.fullName}
            </h1>
          </div>
          <ProfileDetails
            getStaff={getStaffData}
            data={isAuth()?.role === "superadmin" ? superadmin : data}
          />
          <div className="profile-body">
             {isAuth()?.role !== "superadmin" &&
            <span style={{ marginTop: "10px" }}>
              <Box display="flex" justifyContent="flex-end" m={1} p={1}>
                <Controls.Button
                  text="Change Password"
                  variant="outlined"
                  className="newButton"
                  onClick={() => {
                    setOpenPopup(true);
                  }}
                />
              </Box>
            </span>
}
          </div>
        </div>
        <Notification notify={notify} setNotify={setNotify} />

        <Popup
          title="Change Password"
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
        >
          <StaffChangePassword
            NotifyMessage={NotifyMessage}
            setOpenPopup={setOpenPopup}
          />
        </Popup>
      </Admin>
    </Layout>
  );
};

export default ProfilePage;
